/* eslint-disable react-func/max-lines-per-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DccLauncher, DccToolSet } from '@/types/toolSetting';
import service from '@/service';
import { RootState } from './rootReducer';
import { AppThunk } from '.';

type State = {
  projectToolsSets?: Array<DccToolSet>; // 项目工具集
  activeToolsSetId?: string; // 当前激活的工具集id
  activeToolsSetLaunchers?: Array<DccLauncher>; // 当前激活的工具集的launcher列表
  isLoadingLaunchers?: boolean; // 是否正在加载launcher列表
  allLaunchers?: Array<DccLauncher>; // 平台的全量launcher列表
};

const INIT_VALUE = {
  isLoadingLaunchers: true,
};

const initialState: State = INIT_VALUE;

const toolSettings = createSlice({
  name: 'toolSettings',
  initialState,
  reducers: {
    setLoadingLaunchers(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingLaunchers = payload;
    },
    setActiveToolsSetId(state, { payload }: PayloadAction<string | undefined>) {
      state.activeToolsSetId = payload;
    },
    setAllLaunchers(state, { payload }: PayloadAction<Array<DccLauncher>>) {
      state.allLaunchers = payload;
    },
    setActiveToolsSetLaunchers(state, { payload }: PayloadAction<Array<DccLauncher>>) {
      state.activeToolsSetLaunchers = payload;
    },
    setProjectToolsSets(state, { payload }: PayloadAction<Array<DccToolSet>>) {
      state.projectToolsSets = payload;
    },
  },
});

export const {
  setActiveToolsSetId,
  setAllLaunchers,
  setLoadingLaunchers,
  setProjectToolsSets,
  setActiveToolsSetLaunchers,
} = toolSettings.actions;

export const selectToolSettings = (state: RootState) => state.toolSettings;

export const getAllLaunchers = (): AppThunk => async (dispatch, getState) => {
  // const launchersCache = getState()?.toolSettings?.allLaunchers;
  // if (!launchersCache) {
  const launchers = await service.tianGong.getAllLaunchers();
  dispatch(setAllLaunchers(launchers));
  // }
};

export const onActiveProjectChange =
  (projectId): AppThunk =>
  async (dispatch, getState) => {
    if (projectId) {
      const toolSets = await service.tianGong.getProjectToolSets(projectId);
      dispatch(setProjectToolsSets(toolSets));
      const firstToolSet = toolSets?.[0]?.id;
      if (!!firstToolSet) {
        dispatch(setActiveToolsSetId(firstToolSet));
        const launchers = await service.tianGong.getToolsSetLaunchers(firstToolSet);
        dispatch(setActiveToolsSetLaunchers(launchers));
      } else {
        dispatch(setActiveToolsSetId());
        dispatch(setActiveToolsSetLaunchers([]));
      }
    } else {
      dispatch(setProjectToolsSets([]));
      dispatch(setActiveToolsSetId());
      dispatch(setActiveToolsSetLaunchers([]));
    }
  };

export const onActiveToolSetChange =
  (toolsSetId): AppThunk =>
  async (dispatch, getState) => {
    dispatch(setLoadingLaunchers(true));
    if (!toolsSetId) {
      dispatch(setActiveToolsSetLaunchers([]));
    }
    if (toolsSetId) {
      const launchers = await service.tianGong.getToolsSetLaunchers(toolsSetId);
      dispatch(setActiveToolsSetLaunchers(launchers));
    }
    dispatch(setLoadingLaunchers(false));
  };

export default toolSettings.reducer;
